import { GetTrialEmployeesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import companies from 'modules/core/store/collections/companies'

type Props = {
  companyId?: number
}

export const useGetTrialEmployees = () => {
  const currentCompany = companies.current
  const { data, loading } = useQuery(GetTrialEmployeesDocument, {
    variables: {
      companyId: currentCompany.id,
    },
  })

  return {
    loading,
    trialEmployees: data?.trial.trialEmployeesConnection.nodes ?? [],
  }
}
